import PropertyItemTypeEnum from "../PropertyItemTypeEnum";
import PropertyTranslator from "../PropertyTranslator";

// Same value semantics as stringTranslator; only the declared item type differs, so the panel
// renders a multi-line textarea instead of a single-line input.
const multilineStringTranslator: PropertyTranslator<string> = {
    getItemType: () => PropertyItemTypeEnum.MultilineString,

    getDisplayValue: (value) => value,
    setValue: (displayText) => ({ ok: true, value: displayText }),

    isEqual: (a, b) => a === b,

    getListType: () => 'none',

    usesButton: () => false,

    refreshOnEdit: () => true,
};

export default multilineStringTranslator;
